const React = require('react');

const Content = require('../common/Content.jsx');
const ItemMetaCommon = require('../common/ItemMeta.jsx');
const Token = require('../utility/Token.jsx');
const Utilities = require('../utility/Utilities.jsx');

function _ItemMeta(props) {
    const hasValue = !Utilities.isHTMLContentEmpty(props.content);
    return <Content.LabelValue {...props} formatValue={false} renderPlaceholder={!hasValue} value={hasValue ? props.content : undefined} />;
}
const ItemMeta = Content.withLabelTokenParsing(_ItemMeta, (props, keyword, options) => {
    let data = props.itemData || props.data || {};
    if (data.Inventory && props.index < data.Inventory.length) {
        data = data.Inventory[props.index];
    }
    let replaceString = '';
    switch (keyword) {
        case Token.Inventory.Edition:
            if (!Utilities.isNullOrWhitespace(data.EditionNumber)) {
                replaceString = Token.getReplacementString(data.EditionNumber, options);
            }
            break;
        default:
            replaceString = Token.TypeParsing.inventory(props, keyword, options);
            break;
    }
    return replaceString;
});

const TokensItemMeta = (data) => {
    const currencyFormat = Utilities.Format.Currency.getFormatString(data && data.Gallery && data.Gallery.Localization);
    return [
        Token.getWrappedTokenConfig('Title', Token.Inventory.Title),
        Token.getWrappedTokenConfig('Edition Number', Token.Inventory.Edition),
        Token.getWrappedTokenConfig('Created Date', Token.Date),
        Token.getWrappedTokenConfig('Dimensions', Token.Inventory.Dimensions),
        Token.getCurrencyTokenConfig('Retail Price', currencyFormat, Token.Inventory.Price)
    ]
};
const TypeConfigItemMeta = {
    defaultDesign: (data) => `<p class="p">${Utilities.wrapTextForEditor({ text: `{${Token.Inventory.Title}("before":"","after":"")}`, textExtras: `style="display:inline;font-style:italic;"`, token: Token.Inventory.Title, wrapWithTag: false })}${Utilities.wrapTextForEditor({ text: `{${Token.Inventory.Edition}("before":" (","after":")")}`, textExtras: `style="display:inline;"`, token: Token.Inventory.Edition, wrapWithTag: false })}${Utilities.wrapTextForEditor({ text: `{${Token.Date}("before":", ","after":"")}`, textExtras: `style="display:inline;"`, token: Token.Date, wrapWithTag: false })}</p>${Utilities.wrapTextForEditor({ text: `{${Token.Inventory.Dimensions}("before":"","after":"")}`, token: Token.Inventory.Dimensions })}${Utilities.wrapTextForEditor({ text: `{${Token.Inventory.Price}("format":"${Utilities.Format.Currency.getFormatString(data && data.Gallery && data.Gallery.Localization)}")}`, token: Token.Inventory.Price })}`,
    panel: {
        ...ItemMetaCommon.TypeConfig.panel,
        value: (data) => ItemMetaCommon.TypeConfig.panel.value(TypeConfigItemMeta.defaultDesign(data))
    }
};

module.exports = {
    Component: ItemMeta,
    Tokens: TokensItemMeta,
    TypeConfig: TypeConfigItemMeta
}